import { Navigation, Pagination, Swiper } from 'swiper'

Swiper.use([Navigation, Pagination])

document.querySelectorAll('.js-roomGal').forEach((swiperEl) => {
  // eslint-disable-next-line no-new
  new Swiper(swiperEl, {
    loop: true,
    speed: 600,
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: swiperEl.querySelector('.swiper-button-next'),
      prevEl: swiperEl.querySelector('.swiper-button-prev'),
    },
    pagination: {
      el: swiperEl.querySelector('.swiper-pagination'),
      type: 'bullets',
      clickable: true,
    },
  })
})

document.querySelectorAll('.js-roomVideoPlay').forEach((button) => {
  button.addEventListener('click', () => {
    const video = button.closest('.pRoomIntro__video')?.querySelector('.js-roomVideo')
    if (!video) {
      return
    }

    video.play()
    button.classList.add('is-hidden')
  })
})

document.querySelectorAll('.js-roomVideo').forEach((video) => {
  const button = video.closest('.pRoomIntro__video')?.querySelector('.js-roomVideoPlay')

  video.addEventListener('play', () => {
    button?.classList.add('is-hidden')
  })

  video.addEventListener('pause', () => {
    if (!video.ended) {
      button?.classList.remove('is-hidden')
    }
  })

  video.addEventListener('ended', () => {
    button?.classList.remove('is-hidden')
  })
})
